import { ref } from 'vue'
import serve from './request'
import axios from 'axios'

export default {
    post(url, params, options = {}) {
        const cancel = ref()
       return { 
        instance: serve({
                method: 'post',
                url,
                data: params,
                ...options,
                cancelToken: new axios.CancelToken((c) => {
                    cancel.value = c;
                  })
            }),
            cancel 
        }
    
    },
    get(url, params, options = {}) {
        const cancel = ref()
       return { 
        instance: serve({
                method: 'get',
                url,
                params: params,
                ...options,
                cancelToken: new axios.CancelToken((c) => {
                    cancel.value = c;
                  })
            }),
            cancel 
        }
    }
}